























import { defineComponent, ref } from "@vue/composition-api";
import useBreakPoints from "@/hooks/useBreakPoints";
import BaseIconButton from "@/components/BaseIconButton";
import BaseImage from "@/components/BaseImage";
import LandingButton from "../LandingButton";

export default defineComponent({
  name: "HeaderBlock",
  components: { BaseIconButton, BaseImage, LandingButton },
  props: {
    scrolled: { type: Boolean, default: false },
  },
  setup() {
    const { isMobile } = useBreakPoints();
    const showMenu = ref(false);

    return {
      isMobile,
      showMenu,
    };
  },
});
